/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_EquipmentInputs */

const en_us2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was any equipment missing?`)
};

const pt_br2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltou algum equipamento?`)
};

const es_419_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Faltó algún equipo?`)
};

const pt_pt2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltou algum equipamento?`)
};

const fr_fr2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il manquait du matériel ?`)
};

const de_de2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat dir Ausrüstung gefehlt?`)
};

const it_it2_workout_after_equipment = /** @type {(inputs: Workout_After_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancava qualche attrezzo?`)
};

/**
* | output |
* | --- |
* | "Was any equipment missing?" |
*
* @param {Workout_After_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_equipment = /** @type {((inputs?: Workout_After_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_equipment(inputs)
	if (locale === "es-419") return es_419_workout_after_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_equipment(inputs)
	if (locale === "de-DE") return de_de2_workout_after_equipment(inputs)
	if (locale === "it-IT") return it_it2_workout_after_equipment(inputs)
	return en_us2_workout_after_equipment(inputs)
});
export { workout_after_equipment as "workout-after.equipment" }